import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=816082aa&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('816082aa')) {
      api.createRecord('816082aa', component.options)
    } else {
      api.reload('816082aa', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=816082aa&", function () {
      api.rerender('816082aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2487x3oQa2cym/JS/offershelp.vue"
export default component.exports